import { WorkflowElementType } from './Enums/workflow-element-type';

/**
 * Represente une erreur retournée par la validation du workflow.
 */
export class WorkflowValidityError {
    /**
     * Message d'erreur.
     */
    public message: string = null;

    /**
     * Type de l'élément qui est à la source de l'erreur.
     */
    public sourceType: WorkflowElementType = null;

    /**
     * Identifiant de l'élément qui est à la source de l'erreur.
     */
    public sourceId: number = null;

    /**
     * Retourne une copie d'une instance de WorkflowValidityError
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: WorkflowValidityError) {
        if (!!other) {
            const instance = new WorkflowValidityError();
            instance.message = other.message;
            instance.sourceType = other.sourceType;
            instance.sourceId = other.sourceId;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de WorkflowValidityError
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: WorkflowValidityError[]) {
        if (!!others) {
            let errors: WorkflowValidityError[] = [];

            others.forEach((x) => {
                const error = WorkflowValidityError.clone(x);
                errors.push(error);
            });

            return errors;
        } else {
            return [];
        }
    }
}
